const initialExpense = {
    expensesEntry: [],
    expensesdropdown : [],
    expenseEntrymessages:{}
};

const ExpenseEntryReducer = (expenseEntry = initialExpense, action) => {
    switch (action.type) {
        case 'GET_EXPENSE_ENTRY':
            return {
                ...expenseEntry, expensesEntry: action.payload.data
            };
            case "ADD_EXPENSE_ENTRY":
              return {
                ...expenseEntry, expenseEntrymessages: action.payload.data
            };
            case 'APPROVE_EXPENSE_ENTRY':
              return {
                ...expenseEntry, expenseEntrymessages: action.payload.data
            };
            case 'DELETE_EXPENSE_ENTRY':
              return {
                ...expenseEntry, expenseEntrymessages: action.payload.data
            };
            
          default:
            return expenseEntry;
    }
}
export default ExpenseEntryReducer;